
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BackButton extends Vue {
  @Prop({ type: String })
  title!: string;
}
